import { z } from 'zod'

export const DefaultedNullString = z
  .string()
  .nullish()
  .transform((val) => val ?? '');